export const UI_updateCompleteProfileRouteReducer = {
  UI_updateCompleteProfileRoute: (state, action) => {
    state.completeProfileRoute = action.payload;
  },
};
